// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-63a9856c]{position:absolute;z-index:50;height:100vh;width:100vw;--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity))}@media (min-width:1024px){.contentWidthWithNavbar[data-v-63a9856c]{width:calc(100vw - 16rem)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
